// extracted by mini-css-extract-plugin
export default {"Container":"HistoricalDates-module_Container_rggrp","Title":"HistoricalDates-module_Title_v5nAL"};